import { Component, OnInit,  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import * as _ from 'lodash';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { ProxyService } from 'src/app/services/proxy.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
@Component({
  selector: 'app-proxy',
  templateUrl: './proxy.component.html',
  styleUrls: ['./proxy.component.css']
})
export class ProxyComponent implements OnInit {

  proxyForm: FormGroup;
  proList: any[];
  addBtn = true;
  editproxyId: any;
  editParticularData: any;
  dateOfReceiptOfProxyModel: any;
  TodayDate: NgbDateStruct
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  nameOfMemberList: any[];
  disabledOnclick: boolean;
  certificateNoList: any[];
  registerList: any[];
  distinctiveFromList: any[];
  distinctiveToList: any[];
  folioNoDematAcNoList: any[];
  totalNoOfSharesHeld: any[];
  classofSharesList: any[];
  dateOfIssueList: any[];
  noOfSharesAllotedList: any[];
  Mgt1List:any[];
  proxydata: any[];

  constructor(private ProxyService: ProxyService, private activatedRoute: ActivatedRoute,
    private router: Router, private commonFunction: CommonFunction, private customValidation: CustomValidation,
    private alert: AlertComponent, private mgt1Service: Mgt1Service
  ) { }


  ngOnInit() {
    this.proxyForm = new FormGroup({
      folioNumber: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), this.customValidation.noWhitespaceValidator]),
      dematAccountNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.minLength(8), Validators.maxLength(20)]),
      clientId: new FormControl('', []),
      dpId: new FormControl('', []),
      nameOfTheMentor: new FormControl('', [Validators.pattern("^[a-zA-Z' ]*$")]),
      numberOfShares: new FormControl('', []),
      nameOfProxy: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9' ]*$"),  this.customValidation.noWhitespaceValidator]),
      dateOfReceiptOfProxy: new FormControl('', [Validators.required]),
      timeOfReceipt: new FormControl('', []),
      numberOfValidProxies: new FormControl('', []),
      numberOfInvalidProxies: new FormControl('', []),
      remarks: new FormControl('', [])
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['proxyId'] != undefined) {
        this.addBtn = false;
        this.editproxyId = params['proxyId'];
        this.getProxyById(this.editproxyId);
      } else {
        this.addBtn = true;
      }
    })
    this.getRegisterMgt1List();
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };

    $(function () {
      $('.timepicker-init').datetimepicker({
        widgetPositioning: {
          horizontal: 'left'
        },
        icons: {
          time: "fa fa-clock-o",
          date: "fa fa-calendar",
          up: "fa fa-arrow-up",
          down: "fa fa-arrow-down",
          previous: 'fa fa-arrow-left',
          next: 'fa fa-arrow-right'
        },
        format: 'LT'
      });
    })
  }
  getRegisterMgt1List() {
  
    this.nameOfMemberList =[];
    this.folioNoDematAcNoList =[];
    this.totalNoOfSharesHeld =[];
    this.Mgt1List = [];

    this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
      this.Mgt1List.push(MgtList.data);
      for(let i=0; i< MgtList.data.length; i++){
        if(MgtList.data[i].personalDetails.nameOfMember !=""){
         // console.log("************************check8****", this.nameOfMemberList.push({MGT1_id:MgtList.data[i].personalDetails._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember}))
         // console.log("************************check87****", this.nameOfMemberList.push({MGT1_id:MgtList.data[i]._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember}))
        this.nameOfMemberList.push({MGT1_id:MgtList.data[i].personalDetails._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember});
        }
        //this.proxyForm.controls.MGT1Id =  MgtList.data[i]._id;
    }
    this.totalNoOfSharesHeld=MgtList.data;
    this.folioNoDematAcNoList = MgtList.data;
    this.classofSharesList = MgtList.data;
   
     
    });
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['proxyList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
//   getsh2FormDetails(ev,value){
//     // const selectEl = ev.target;
//     const MGT1_id = ev.target.options[ev.target.selectedIndex].getAttribute('data-mgt1id');
//     // console.log('%%%%%%%%%%%%%%',MGT1_id)
//     this.proxyForm.controls.mgt1Id = MGT1_id;
//  } 

 getsh2FormDetails(ev,value){
   //var id = ev.target.value;
   
   console.log("************ev.target.attributes.id;**********1*************ev.target.value",ev.target.getAttribute('data-mgt1id'));
   console.log("************ev.target.attributes.id;**********1*************ev.target.value",ev.target.options[ev.target.selectedIndex].getAttribute('data-mgt1id'));
  // if(id == null || id == undefined || id == 'null')
  // {

  // }
  // this.proxydata = this.Mgt1List[0]
  // for(let i=0; i< this.proxydata.length; i++){
  //   console.log("***********************************element",this.proxydata[i]);

  //   this.proxydata[i].forEach(item => {
  //     console.log("-------------------item",item);
  //     console.log("this.proxydata[i].personalDetails.nameOfMember",this.proxydata[i].personalDetails.nameOfMember);
     
  //     })
  // }
  this.Mgt1List.forEach(element => {
    console.log("***********************************element",element);

   // element.detailsOfHoldings.forEach(item => {
    for(let i=0; i<element.length; i++){
      if(element[i].personalDetails.nameOfMember == value){
        console.log("************************match************",element[i].personalDetails.nameOfMember == value)
       // this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(element.personalDetails.nameOfMember);
       this.proxyForm.controls.folioNumber.setValue(element[i].folioNoDematAcNo);
       this.proxyForm.controls.numberOfShares.setValue(element[i].totalNoOfSharesHeld);
      //  this.proxyForm.controls.MGT1Id.setValue(element[i]._id);
       this.proxyForm.controls.MGT1Id =  element[i]._id;
      }
    }
   // })
  });
} 

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  saveProxy() {
    this.disabledOnclick = true;

    var object = {
      folioNumber: this.proxyForm.controls.folioNumber.value,
      dematAccountNumber: this.proxyForm.controls.dematAccountNumber.value,
      clientId: this.proxyForm.controls.clientId.value,
      dpId: this.proxyForm.controls.dpId.value,
      nameOfTheMentor: this.proxyForm.controls.nameOfTheMentor.value,
      numberOfShares: this.proxyForm.controls.numberOfShares.value,
      nameOfProxy: this.proxyForm.controls.nameOfProxy.value,
      dateOfReceiptOfProxy: this.setDate(this.proxyForm.controls.dateOfReceiptOfProxy.value),
      timeOfReceipt: this.proxyForm.controls.timeOfReceipt.value,
      numberOfValidProxies: this.proxyForm.controls.numberOfValidProxies.value,
      numberOfInvalidProxies: this.proxyForm.controls.numberOfInvalidProxies.value,
      remarks: this.proxyForm.controls.remarks.value,
      mgt1Id:this.proxyForm.controls.MGT1Id
    }

    // this.ProxyService.sampleProRecord(object).subscribe(response => {
    this.ProxyService.saveProxyRecord(object).subscribe(response => {
      console.log("****************************************************response",response);
      this.disabledOnclick = false;
      if (response.status == 0) {
       

        this.alert.successWithOk(response.message, 'proxyList');
      } else {
        // this.alert.error(response.message);
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        console.log("****************************************************response.err_fields",response.err_fields);
        }
        else{
          this.alert.error(response.message);
        }
      }
    })
  }

  getProxyById(proxyId) {
    this.ProxyService.getproxyById(proxyId).subscribe(response => {
      this.editParticularData = response.data[0];
       console.log(" this.editParticularData", this.editParticularData);
      // console.log(" this.editParticularData", this.editParticularData.mgt1Id);

      // this.proxyForm.controls.mgt1Id =this.editParticularData.mgt1Id


      this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
         this.Mgt1List.push(MgtList.data);
        MgtList.data.forEach(element => {
          console.log("__________ this.element", element._id == this.editParticularData.mgt1Id);
          if( element._id == this.editParticularData.mgt1Id){
          this.proxyForm.controls.nameOfTheMentor.setValue(element.personalDetails.nameOfMember);
          this.proxyForm.controls.folioNumber.setValue(element.folioNoDematAcNo);
          this.proxyForm.controls.numberOfShares.setValue(element.totalNoOfSharesHeld);
          return false
          }
        })
      });
     // this.proxyForm.controls.folioNumber.setValue(this.editParticularData.folioNumber);
      this.proxyForm.controls.dematAccountNumber.setValue(this.editParticularData.dematAccountNumber);
      this.proxyForm.controls.clientId.setValue(this.editParticularData.clientId);
      this.proxyForm.controls.dpId.setValue(this.editParticularData.dpId);
      //this.proxyForm.controls.nameOfTheMentor.setValue(this.editParticularData.nameOfTheMentor);
      //this.proxyForm.controls.numberOfShares.setValue(this.editParticularData.numberOfShares);
      this.proxyForm.controls.nameOfProxy.setValue(this.editParticularData.nameOfProxy);
      // this.proxyForm.controls.dateOfReceiptOfProxy.setValue(this.editParticularData.dateOfReceiptOfProxy);
      this.proxyForm.controls.timeOfReceipt.setValue(this.editParticularData.timeOfReceipt);
      this.proxyForm.controls.numberOfValidProxies.setValue(this.editParticularData.numberOfValidProxies);
      this.proxyForm.controls.numberOfInvalidProxies.setValue(this.editParticularData.numberOfInvalidProxies);
      this.proxyForm.controls.remarks.setValue(this.editParticularData.remarks);

      if (this.editParticularData.dateOfReceiptOfProxy != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfReceiptOfProxy));
        this.dateOfReceiptOfProxyModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    });
  }

 




  updateProxy() {
    this.disabledOnclick = true;

    var object = {
      folioNumber: this.proxyForm.controls.folioNumber.value,
      dematAccountNumber: this.proxyForm.controls.dematAccountNumber.value,
      clientId: this.proxyForm.controls.clientId.value,
      dpId: this.proxyForm.controls.dpId.value,
      nameOfTheMentor: this.proxyForm.controls.nameOfTheMentor.value,
      numberOfShares: this.proxyForm.controls.numberOfShares.value,
      nameOfProxy: this.proxyForm.controls.nameOfProxy.value,
      dateOfReceiptOfProxy: this.setDate(this.proxyForm.controls.dateOfReceiptOfProxy.value),
      timeOfReceipt: this.proxyForm.controls.timeOfReceipt.value,
      numberOfValidProxies: this.proxyForm.controls.numberOfValidProxies.value,
      numberOfInvalidProxies: this.proxyForm.controls.numberOfInvalidProxies.value,
      remarks: this.proxyForm.controls.remarks.value,
      mgt1Id:this.proxyForm.controls.MGT1Id
    }
    this.ProxyService.updateProxy(object, this.editproxyId).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        

        this.alert.successWithOk(response.message, 'proxyList');
      } else {
    if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
    }
    else{
      this.alert.error(response.message);
    }
      }

    });
  }
  getTimeOfInspection() {
    this.proxyForm.controls.timeOfReceipt.setValue($('#fromTimeOfInspection').val());
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  generateOutput() {
    var object = {
      id: this.editproxyId,
      fromDate: null, 
      toDate: null,
      folioNumber: null
    }
    this.ProxyService.generateProxyDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editproxyId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editproxyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.ProxyService.downloadProxyFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.ProxyService.downloadProxyPdfFile(id, 'Single');
  }

}

